import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
  imports: [NgClass],
})
export class LoadingSpinnerComponent {
  @Input() label = 'Loading';
  @Input() type = 'block';
}
